import BaseService from '@/api/services/index'

export interface RetailCrmCategoryGroup {
    id: number;
    name: string;
    path: string;
}

export interface CategoryMappingItem {
    retailCrmCategoryId: number;
    marketCategoryId: number;
    marketCategory: {
        marketCategoryId: number;
        name: string;
        path: string;
    } | null;
    valid: boolean;
}

export interface CategoryMappingsResponse {
    groups: RetailCrmCategoryGroup[];
    mappings: CategoryMappingItem[];
}

export interface MarketCategorySearchResult {
    marketCategoryId: number;
    name: string;
    path: string;
}

export default class CategoryMappingService extends BaseService {
    public async getCategoryMappings (accountId: number|undefined, campaignId: number): Promise<CategoryMappingsResponse> {
        return this.api.get<never, CategoryMappingsResponse>(
            this.getUrl('account_campaign_category_mapping_get', { accountId, campaignId })
        )
    }

    public async searchCategories (accountId: number|undefined, campaignId: number, query: string): Promise<MarketCategorySearchResult[]> {
        return this.api.get<{ q: string }, MarketCategorySearchResult[]>(
            this.getUrl('account_campaign_category_mapping_market_categories', { accountId, campaignId }),
            { q: query }
        )
    }

    public async saveCategoryMapping (accountId: number|undefined, campaignId: number, retailCrmCategoryId: number, marketCategoryId: number): Promise<void> {
        return this.api.put< { marketCategoryId: number }, void >(
            this.getUrl('account_campaign_category_mapping_put', { accountId, campaignId, retailCrmCategoryId }),
            { marketCategoryId }
        )
    }

    public async deleteCategoryMapping (accountId: number|undefined, campaignId: number, retailCrmCategoryId: number): Promise<void> {
        return this.api.delete<never, void>(
            this.getUrl('account_campaign_category_mapping_delete', { accountId, campaignId, retailCrmCategoryId })
        )
    }
}
